import React, { useEffect, useState } from 'react';
import './Skills.css';
import { getSkills } from '../queries/getSkills';
import { Skill } from '../types';

// 1. REMOVED all imports from 'react-icons'

// 2. ADDED imports for your new local icon components
// Make sure the path '../icons/' is correct based on your folder structure
import ReactIcon from './icons/ReactIcon';
import TypescriptIcon from './icons/TypescriptIcon';
import Html5Icon from './icons/Html5Icon';
import TailwindCssIcon from './icons/TailwindCssIcon';
import Css3Icon from './icons/Css3Icon';
import NodeJsIcon from './icons/NodeJsIcon';
import JavaIcon from './icons/JavaIcon';
import SpringbootIcon from './icons/SpringbootIcon';
import FlaskIcon from './icons/FlaskIcon';
import OpenAiIcon from './icons/OpenAiIcon';
import OpencvIcon from './icons/OpencvIcon';
import ApiIcon from './icons/ApiIcon';
import AwsIcon from './icons/AwsIcon';
import DockerIcon from './icons/DockerIcon';
import PostgresqlIcon from './icons/PostgresqlIcon';
import MysqlIcon from './icons/MysqlIcon';
import KubernetesIcon from './icons/KubernetesIcon';
import GoogleCloudIcon from './icons/GoogleCloudIcon';
import FirebaseIcon from './icons/FirebaseIcon';
import MongodbIcon from './icons/MongodbIcon';
import GitIcon from './icons/GitIcon';
import GithubIcon from './icons/GithubIcon';


// 3. UPDATED the iconMap to use your new local components
const iconMap: { [key: string]: React.ComponentType<{ size?: number }> } = {
  // Frontend
  'React': ReactIcon,
  'TypeScript': TypescriptIcon,
  'HTML': Html5Icon,
  'Tailwind CSS': TailwindCssIcon,
  'CSS': Css3Icon,

  // Backend
  'Node.js': NodeJsIcon,
  'Java': JavaIcon,
  'Spring Boot': SpringbootIcon,
  'Flask': FlaskIcon,
  
  // AI & ML
  'OpenAI API': OpenAiIcon,
  'OpenCV': OpencvIcon,
  'Gemini API': ApiIcon,
  'OpenRouter': ApiIcon,
  'LiteLLM': ApiIcon,
  'Google_ADK': ApiIcon,

  // Cloud & Databases
  'AWS': AwsIcon,
  'Docker': DockerIcon,
  'PostgreSQL': PostgresqlIcon,
  'MySQL': MysqlIcon,
  'Kubernetes': KubernetesIcon,
  'GCP': GoogleCloudIcon,
  'Firebase': FirebaseIcon,
  'MongoDB': MongodbIcon,

  // Tools
  'Git': GitIcon,
  'GitHub': GithubIcon,
};


const Skills: React.FC = () => {
  const [skillsData, setSkillsData] = useState<Skill[]>([]);

  useEffect(() => { 
    async function fetchSkills() {
      const data = await getSkills();
      setSkillsData(data);
    }
    fetchSkills()
  }, []);

  if (skillsData.length === 0) return <div>Loading...</div>;

  const skillsByCategory = skillsData.reduce((acc: any, skill: any) => {
    if (!acc[skill.category]) acc[skill.category] = [];
    acc[skill.category].push(skill);
    return acc;
  }, {});


  return (
    <div className="skills-container">
      {Object.keys(skillsByCategory).map((category, index) => (
        <div key={index} className="skill-category">
          <h3 className="category-title">{category}</h3>
          <div className="skills-grid">
            {skillsByCategory[category].map((skill: any, idx: number) => {
              // The key for the map is now the skill's name
              const IconComponent = iconMap[skill.name] || ReactIcon; // Fallback icon
              return (
                <div key={idx} className="skill-card">
                  <div className="icon"><IconComponent size={40} /></div>
                  <h3 className="skill-name">
                    {skill.name.split('').map((letter: any, i: number) => (
                      <span key={i} className="letter" style={{ animationDelay: `${i * 0.05}s` }}>
                        {letter}
                      </span>
                    ))}
                  </h3>
                  <p className="skill-description">{skill.description}</p>
                </div>
              )
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Skills;